export enum QuantityUnit {
    KILOGRAMS = "kg",
    GRAMS = "g",
    PIECES = "piece",
}
